/**
 * file : AllTournament/Tap/HallOfFame.jsx
 * 설명 : 명예의 전당
 */

import Icon1 from "assets/images/icon_place1.png"
import Icon2 from "assets/images/icon_place2.png"
import Icon3 from "assets/images/icon_place3.png"

import { Fnc } from "common/globals";
import { useEffect, useState } from "react";
import { Search } from "components/Common/ApiCall";

export default function HallOfFame() {
  // 이미지
  const imgs = [Icon1, Icon2, Icon3]
  // 순위 클래스 명
  const rankClass = ['bg1', 'bg2', 'bg0']
  // 데이터
  const [datas, setDatas] = useState();
  // 조회
  useEffect(() => {
    Search('/hall-of-fame', setDatas)
  }, [])
  
  return (
    <div className="zeus-tab-item tab-show">
        <div className="honor">
          <div className="box box_style1">
            <h2>입상 명예의 전당</h2>
          <ul>
            {
              !Fnc.Empty(datas) && datas.prize_cnt_list.map((data, index) => (
                index < 3 
                ? (
                  <li key={index}>
                    <div><img src={imgs[index]} alt={index +1} /></div>
                    <div><span className={rankClass[index]}>{index +1}위</span>{data.user_id}</div>
                    <div>{data.prize_cnt}회</div>
                  </li>
                )
                : (
                  <li key={index}>
                    <div>{index +1}위</div>
                    <div>{data.user_id}</div>
                    <div>{data.prize_cnt}회</div>
                  </li>
                )
              ))
            }
          </ul>
        </div>
        <div className="box box_style1">
            <h2>상금 명예의 전당</h2>
          <ul>
            {
              !Fnc.Empty(datas) && datas.settlement_amount_list.map((data, index) => (
                index < 3 
                ? (
                  <li key={index}>
                    <div><img src={imgs[index]} alt={index +1} /></div>
                    <div><span className={rankClass[index]}>{index +1}위</span>{data.user_id}</div>
                    <div><span className="won"></span>{data.settlement_amount.toLocaleString()}</div>
                  </li>
                )
                : (
                  <li key={index}>
                    <div>{index +1}위</div>
                    <div>{data.user_id}</div>
                    <div><span className="won"></span>{data.settlement_amount.toLocaleString()}</div>
                  </li>
                )
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  )
}